<script>
  import Header from './components/Header.svelte'
  import Introduction from './components/Introduction.svelte'
  import Presentation from './components/Presentation.svelte'
  import France from './components/France.svelte'
  import Modules from './components/Modules.svelte'
  import FeedBacks from './components/FeedBacks.svelte'
  import Price from './components/Price.svelte'
  import Questions from './components/Questions.svelte'
  import Footer from './components/Footer.svelte'
  import Bonus from './components/Bonus.svelte'
  import Section from './components/Section.svelte'
</script>

<style>

</style>

<main>
  <Header />
  <Introduction />
  <Presentation />
  <France />
  <Modules />
  <Bonus />
  <FeedBacks />
  <Section />
  <Price />
  <Questions />
  <Footer />
</main>
